import script from "./AppointmentFilterButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointmentFilterButton.vue?vue&type=script&setup=true&lang=js"

import "./AppointmentFilterButton.vue?vue&type=style&index=0&id=99d399ea&lang=scss"

const __exports__ = script;

export default __exports__